import { jsxs as b, jsx as r } from "react/jsx-runtime";
import { forwardRef as x, useId as g } from "react";
import h, { components as S } from "react-select";
import { zIndex as w } from "../../theme/theme.js";
import { cn as i } from "../../utils.js";
import { ErrorMessage as y } from "../ErrorMessage/index.js";
import { Typography as v } from "../Typography/index.js";
import { InputLabel as I } from "../InputLabel/index.js";
const M = {
  menuPortal: (n) => ({
    ...n,
    pointerEvents: "auto",
    zIndex: w.select
    //zIndex.dialog
  })
};
function N({
  label: n,
  required: l,
  errors: o,
  helperText: a,
  isReadOnly: s,
  rounded: c,
  className: u,
  mountOnBody: m,
  ...t
}, f) {
  const p = g(), d = t.id || p;
  return s && (t.menuIsOpen = !1, t.isSearchable = !1, t.isClearable = !1), /* @__PURE__ */ b("div", { className: i("w-full", u), children: [
    n && /* @__PURE__ */ r(I, { label: n, required: l, htmlFor: d }),
    /* @__PURE__ */ r(
      h,
      {
        ref: f,
        id: d,
        menuPortalTarget: m ? document.body : void 0,
        components: {
          Menu: (e) => /* @__PURE__ */ r(S.Menu, { ...e, className: "react-select-menu" })
        },
        styles: M,
        classNames: {
          control: (e) => i(
            " !min-h-[44px] !text-body !leading-5 !shadow-none !bg-white !border !border-onSurface-800",
            {
              "focus-within:!ring-2 focus-within:!ring-offset-1 !ring-interactive-400": e.isFocused,
              "focus-within:!ring-0 !shadow-0 !border-critical-500 !bg-critical-500": e.isDisabled && !!o,
              "focus-within:!ring-0 !shadow-0 !border-onSurface-300 !bg-onSurface-50 !text-onSurface-400": e.isDisabled && !o,
              "!rounded-full": c,
              "!rounded-md": !c,
              "!border-critical-500 !bg-critical-50": !!o
            }
          ),
          menu: () => i(
            "!bg-white !rounded-md !border !border-surface-200 !border-solid !shadow-[0px_6px_15px_0px_#0000000D] !my-1"
          ),
          menuList: () => "!py-0.5",
          option: (e) => i(
            " !w-[auto] !bg-white-500 !text-onSurface-900 !width-[auto]active:!bg-onSurface-200 disable:!bg-white-500 disabled:!text-onSurface-400 !rounded !mx-1 !my-0.5 !px-1 !py-1.25 hover:!bg-onSurface-100",
            {
              "!bg-primary-50 !text-primary-600 ": e.isSelected
            },
            {
              "!bg-onSurface-100": e.isFocused
            }
          ),
          dropdownIndicator: () => "!p-1 !text-onSurface-300",
          clearIndicator: () => "!p-1 !text-onSurface-300",
          valueContainer: () => "!py-[2px] !pl-1.5 !pr-1",
          placeholder: () => "!text-onSurface-400 !mx-[2px]",
          indicatorSeparator: () => "!bg-onSurface-300 !my-1",
          multiValue: () => "!bg-[#e6e6e6] !m-0.25 !rounded-sm",
          multiValueLabel: () => "!overflow-hidden !text-ellipsis !whitespace-nowrap !text-[hsl(0,0%,20%)] !text-[85%] !box-border !pl-[6px] !p-[3px] !rounded-sm",
          multiValueRemove: () => "!items-center !flex !box-border !px-0.5 !rounded-sm",
          noOptionsMessage: () => "!text-center !text-[#999999] !box-border !px-1.5 !py-1"
        },
        ...t
      }
    ),
    !o && a && /* @__PURE__ */ r(v, { variant: "smallBody", className: "mt-0.5 text-onSurface-500", children: a }),
    o && /* @__PURE__ */ r(y, { title: o })
  ] });
}
const z = x(N);
export {
  z as Select
};
